export const policy_details = [
  {
    key:"1",
    Name: "Employee",
    Department: "All Department",
    Description: "Guidelines regarding employee absences from work",
    CreatedDate: "14 Jan 2024",
  },
  {
    key:"2",
    Name: "Permission Policy",
    Department: "Marketing",
    Description: "Guidelines for accessing and using company resources",
    CreatedDate: "21 Jan 2024",
  },
  {
    key:"3",
    Name: "Privacy Policy",
    Department: "All Department",
    Description: "Ensure compliance with data protection",
    CreatedDate: "18 Feb 2024",
  },
];
